export default __webpack_public_path__ + "static/media/SourceSansPro-ExtraLight.57c42ad7.ttf";